<!-- enInfo 含能材料每期英文信息设置 -->
<template>
  <div class="enInfo">
    <el-form ref="ruleForm" :model="ruleForm" label-width="138px">
      <div class="part">
        <div class="left-part">
          <img :src="enInfoImg" alt="" />
        </div>
        <div class="right-part">
          <div class="flex-content">
            <div class="left">
              <el-form-item label="英文信息背景图片：" size="zdy4" prop="articleBackdrop">
                <div class="mag-cover upload-img">
                  <img :src="articleBackdropCoverSrc" alt />
                  <el-upload
                    class="upload-demo"
                    :action="UploadPictureStream"
                    name="file"
                    :show-file-list="false"
                    accept=".png,.jpg,.jpeg"
                    :auto-upload="true"
                    :on-success="handleArticleBackdropCoverSuccess"
                  >
                    <el-button class="upload-btn" size="small" type="primary">上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="el-upload__tip"><el-button @click="resetImg" style="margin: 0px 20px 0 27px">重置</el-button>格式支持：jpg、png、jpeg<span class="betterSize">尺寸推荐：156*231</span></div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { GetPictureStream, UploadPictureStream } from '@/api/configManage'
export default {
  name: 'enInfo',
  data() {
    return {
      morImg: require('@/assets/img/template_img/hncl/module10.png'),
      enInfoImg: require('@/assets/img/template_img/hncl/module10.png'),
      GetPictureStream: GetPictureStream,
      UploadPictureStream: UploadPictureStream,
      articleBackdropCover: ''
    }
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  watch: {
    magId() {
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
      })
    }
  },
  computed: {
    // 英文信息背景图片
    articleBackdropCoverSrc() {
      return this.articleBackdropCover ? this.articleBackdropCover : this.ruleForm.articleBackdrop ? `${this.GetPictureStream}?pictureId=${this.ruleForm.articleBackdrop}` : this.morImg
    }
  },
  created() {},
  methods: {
    handleArticleBackdropCoverSuccess(res, file) {
      const { data } = res
      const { ID } = data
      this.articleBackdropCover = URL.createObjectURL(file.raw)
      this.$set(this.ruleForm, 'articleBackdrop', ID)
    },
    resetImg() {
      this.articleBackdropCover = this.morImg
      this.ruleForm.articleBackdrop = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.enInfo {
  .left-part {
    height: 277px;
    img {
      height: 100%;
      object-fit: contain;
    }
  }
  .mag-cover {
    width: 156px;
    height: 231px;
  }
}
</style>
